import { DEFAULT_MAX_IMAGE_UPLOAD_SIZE_MB } from '../../../utils/constants';
import { SupportedLanguages } from '../../shared/supported-languages';

export interface EditorLocaleSettings {
  language: SupportedLanguages;
  dateFormat: string;
  timeFormat: string;
  numberFormat: {
    thousandsSeparator: '.' | ',' | ' ';
    decimalSeparator: '.' | ',';
  };
}

const DEFAULT_LOCALE: EditorLocaleSettings = {
  language: 'de',
  dateFormat: 'dd.MM.yyyy',
  timeFormat: 'HH:mm:ss',
  numberFormat: {
    thousandsSeparator: '.',
    decimalSeparator: ','
  }
};

const LOCALES: Record<SupportedLanguages, EditorLocaleSettings> = {
  de: { ...DEFAULT_LOCALE },
  en: {
    ...DEFAULT_LOCALE,
    language: 'en',
    dateFormat: 'MM-dd-yyyy',
    timeFormat: 'HH:mm:ss',
    numberFormat: {
      thousandsSeparator: ',',
      decimalSeparator: '.'
    }
  }
};

export class EditorSettings {
  // locale settings
  language: EditorLocaleSettings['language'];
  dateFormat: EditorLocaleSettings['dateFormat'];
  timeFormat: EditorLocaleSettings['timeFormat'];
  numberFormat: EditorLocaleSettings['numberFormat'];

  // ui settings
  theme = 'dark';

  // max upload size for images in megabytes (MB), default to 20 MB if not set by backend
  maxImageUploadSize = DEFAULT_MAX_IMAGE_UPLOAD_SIZE_MB;

  constructor(locale: SupportedLanguages = 'de') {
    const localeSettings = LOCALES[locale];
    this.language = localeSettings.language;
    this.dateFormat = localeSettings.dateFormat;
    this.timeFormat = localeSettings.timeFormat;
    this.numberFormat = localeSettings.numberFormat;
  }
}
